import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-debug-form',
  templateUrl: './debug-form.component.html',
  styleUrls: ['./debug-form.component.scss'],
  standalone: false,
})
export class DebugFormComponent implements OnInit {
  @Input() form: FormGroup | FormArray;
  @Input() raw: boolean = false;
  get hidden(): boolean {
    return environment.production;
  }

  get isLokaleOmgeving() {
    return window.location.origin.includes('localhost');
  }
  constructor() {}

  ngOnInit(): void {}
}
